import axios from '../utils/axios';

export default function fetchTagMailers(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/tag-mailers', { params })
    )
}
